<div class="flex min-w-0 flex-auto flex-col items-center">
    <div
      class="flex flex-col items-center justify-center relative w-full sm:h-40 md:h-50 bg-gray-100 border-2 border-dashed border-gray-300 p-2 rounded-md"
      (dragover)="onDragOver($event)"
      (dragleave)="onDragLeave($event)"
      (drop)="onDrop($event)">
      
        <div class="font-bold mb-2 hidden md:flex">Seleccione un Archivo o Arrastrelo Aquí</div>
        <button (click)="uploadImage()" class="w-8/12 md:w-4/12 h-12 border border-gray-300 rounded-md flex items-center justify-center bg-[#f4f4f4] hover:bg-[#e0e0e0]">
          <mat-icon class="">cloud_upload</mat-icon>
          <p class="pl-2 text-sm md:text-lg">Seleccionar Archivos</p>
        </button>
  
        <input
          type="file"
          accept="image/jpeg, image/png"
          multiple
          (change)="onFileSelected($event)"
          class="hidden"
          #fileInput>
    </div>

    <!-- Formulario de créditos -->
    <div class="w-full mt-4">
      <div class="flex flex-col md:flex-row items-center gap-2">
        
        <div class="flex w-full h-10 border border-gray-300 rounded-md overflow-hidden">
          <label class="w-4/12 md:w-3/12 bg-gray-600 text-white flex items-center justify-center px-2 text-sm font-semibold">
            FOTOGRAFIADO POR
          </label>
          <input
            matInput
            id="fotografiadoPor"
            name="fotografiadoPor"
            [(ngModel)]="fotogragiadoPor"
            placeholder="Nombre del autor"
            class="w-8/12 px-3 text-sm focus:outline-none" />
        </div>

        <button
          mat-raised-button
          color="primary"
          class="w-full md:w-auto mt-2 md:mt-0 rounded-md"
          (click)="fotografiadoPor()"
          [disabled]="!fotogragiadoPor">
          Guardar Créditos
        </button>
      </div>
    </div>

    <div class="hidden md:flex justify-center w-full">
      <div class="grid grid-cols-4 gap-6 my-4">
          <fuse-card class="flex w-full max-w-90 min-w-50 max-h-72 flex-col p-2 bg-gray-50"
          *ngFor="let img of archivosGaleria$ | async; let i = index">
            <img
                class="object-cover h-50 bg-slate-100 rounded-md"
                [src]="img.blobURL"
                alt="Image"
            />
            <div class="mx-2 mt-4">
              <div class="flex justify-between">
                  <div class="flex flex-col w-10/12">
                      <div class="w-full bg-white border border-gray-300 rounded-md">
                        <input type="text" name="nombre_img" id="nombre_img" 
                          [(ngModel)]="img.nombreArchivo"
                          class="w-full text-xs md:text-md font-semibold truncate px-2 py-1" 
                          (focus)="guardarOriginal(img)"
                          (blur)="actualizarNombreSiCambio(img)">
                      </div>
                      <div
                          class="text-secondary text-md"
                      >
                      {{ img.fechaModificacion | date }}
                      </div>
                  </div>
                  <div class="gap-2 w-2/12" >
                      <mat-icon *ngIf="!img.favorito"
                        (click)="archivoFavorito(img.archivoId)"
                        class="icon-size-5 hover:text-red-600"
                        [svgIcon]="'heroicons_outline:star'"
                      ></mat-icon>
                      <mat-icon *ngIf="img.favorito"
                        (click)="archivoFavorito(img.archivoId)"
                        class="icon-size-5"
                        [ngStyle]="{'color': img.favorito ? 'red' : ''}"
                        [svgIcon]="'heroicons_solid:star'"
                      ></mat-icon>

                      <mat-icon  (click)="removeImage(img.archivoId)"
                          class="icon-size-5 hover:text-red-600"
                          [svgIcon]="'heroicons_outline:x-circle'"
                      ></mat-icon>
                  </div>
              </div>
          </div>
          </fuse-card>
      </div>
    </div>

    <div class="md:hidden flex justify-center w-full">
      <div
        class="grid grid-col-1 md:grid-cols-2 gap-6 my-2 md:m-4 w-full"
        *ngIf="archivosGaleria"
      >
      <fuse-card
          class="filter-info flex w-full overflow-hidden bg-gray-50"
          *ngFor="let img of archivosGaleria$ | async; let i = index"
        >
          <img
            class="w-20 h-20 md:w-44 md:h-40 object-cover bg-slate-100 flex-shrink-0 m-2 rounded-lg"
            [src]="img.blobURL"
            alt=""
          />

          <div class="flex flex-1 items-start justify-between w-full p-2 min-w-0">
            <div class="min-w-0">
              <div class="w-full bg-white">
                <input type="text" (blur)="actualizarNombre(img.nombreArchivo, img.archivoId)"
                  name="nombre_img" 
                  id="nombre_img" 
                  [(ngModel)]="img.nombreArchivo"
                  class="w-full text-xs md:text-md font-semibold truncate bg-white">
              </div>
              <div class="text-xs md:text-md">
                {{ img.fechaModificacion | date }}
              </div>
            </div>

            <div class="flex gap-2 flex-shrink-0">
              <mat-icon *ngIf="!img.favorito"
                  (click)="archivoFavorito(img.archivoId)"
                  class="icon-size-5 hover:text-red-600"
                  [svgIcon]="'heroicons_outline:star'"
                ></mat-icon>
                <mat-icon *ngIf="img.favorito"
                  (click)="archivoFavorito(img.archivoId)"
                  class="icon-size-5"
                  [ngStyle]="{'color': img.favorito ? 'red' : ''}"
                  [svgIcon]="'heroicons_solid:star'"
                ></mat-icon>

                <mat-icon  (click)="removeImage(img.archivoId)"
                    class="icon-size-5 hover:text-red-600"
                    [svgIcon]="'heroicons_outline:x-circle'"
                ></mat-icon>
            </div>
          </div>
        </fuse-card>

    
      </div>
    </div>

    <div class="w-full flex items-start mt-4">
      <span><strong>Fotografiado Por:</strong> {{nombreFotografo}}</span>
    </div>
    
  </div>
  